import { connect } from 'react-redux'

import { SameIssuesHistoryButton } from '../components/SameIssuesHistory'
import { setModal } from '../actions/modal-actions'
import { MODAL_SAME_ISSUES_HISTORY } from '../constants'
import FaultsService from '../services/faults'
import { getElementIdField } from '../helpers/element'

const mapStateToProps = (state) => {
  const { elements: currentComponents } = state.componentState
  const componentStates = state.loggingState.componentStates
  const currentComponentsId = currentComponents.map(
    (component) => component[getElementIdField(component)],
  )
  const totalIssuesCount =
    FaultsService.getTotalHistoryCountFromComponentStates(
      componentStates,
      currentComponentsId,
    )
  const hasSameIssuesHistory = totalIssuesCount > 0

  return {
    hasSameIssuesHistory,
    totalIssuesCount,
  }
}

export { mapStateToProps }

const mapDispatchToProps = (dispatch) => ({
  openSameIssuesHistory: () => dispatch(setModal(MODAL_SAME_ISSUES_HISTORY)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SameIssuesHistoryButton)
